/**
 * Scenarios to handle
 *
 * 1. Billing-screen for nura-desk
 *
 * 2. Billing-screen for stoptb
 *
 * 3. Direct-Billing for alsalama
 *
 */

import React, { useEffect, useState, useContext } from 'react';

import { Typography, Modal, Skeleton, Form, Input, Select, Col, message, Checkbox, Popconfirm } from 'antd';

import './bill-items.scss';

import { Location, ReferenceSelect, GlobalContext, useTranslation, Trans, Button, Card } from 'soxo-bootstrap-core';

import { withRouter } from 'react-router-dom';

import { ItemSelection } from '../../../items/components/item-selection/item-selection';

import { Categories, Referrers, Items, Bills, Opvisits, Opreg, ItemRateTypes, Appointments, Customers } from '../../../../models';

import GuestInformation from './components/guest-information/guest-information';

import CouponModal from './components/coupon-model/coupon-model';

import DiscountModal from '../discount-model/discount-model';

import SelectedList from './components/selected-list/selected-list';

import { formatCurrency } from '../../../../utils/currency.utils';

import './bill-items.scss';
import PriceFormatter from '../format-price/format-price';

import Coupon from '../../components/coupon/coupon';

import CollectionAdd from '../../../reception/components/collections/collections-add';

const { Option } = Select;

const { Title, Text } = Typography;

const { TextArea } = Input;

function BillItems({
    defaultItem,
    buttonEnable,
    doctorSelectionDisable,
    callback,
    order,
    referrer,
    disableBillDiscount,
    disableBillCoupon,
    enableItemDiscount,
    // autoCollectionRedirect, // collection add navigation controlled by this attribute
    enableCorporateReferrerMap, // for corporatereferrer maping
    // enable corporate and referrer for authorized person
    disableCorporate,
    disableReferrer,
    partyType,
    //To manage Corporate Payable, Patient Payable and Advance from Billing and Order detail Screens for Pura
    enableCorpPayable,
    enableAdvance,
    enablePatientPayable,
    showWalletDetails,
    /**
     * Controls whether the doctor selector should be displayed.
     * This is determined by an attribute. If set to `true`, the doctor selector will be shown.
     */
    enableDoctorSelection,
    ...props
}) {
    var urlParams = Location.search();

    var params = Location.search();

    const [guest, setGuest] = useState({});

    // Master for each dropdowns
    const [types, setTypes] = useState([]);

    const [referreroptions, setReferreroptions] = useState([]);

    // Variables to record user selection/ preference
    // Note : These variables can be replaced with implementation of
    // form items .

    const [selectedbilltype, setSelectedbilltype] = useState('');

    const [selectedcategory, setSelectedcategory] = useState('GEN');

    const [category, setCategory] = useState([]);

    const [corporate, setCorporate] = useState(false);

    const [selectedCorporate, setSelectedCorporate] = useState('');

    const [alert, setAlert] = useState(false);

    const [itemRateData, setItemRateData] = useState(false);

    // Variable to save the remarks of the bill.
    const [remarks, setRemarks] = useState('');

    // Variable to save the discount of the bill.
    const [discount, setDiscount] = useState({});

    // State is used to disable corporate and referrer if they are related to a coupon.
    const [disabledfield, setDisableField] = useState({
        setSelectedreferrerdisabled_referrer: false,
        disabled_corporate: false,
        disabled_corporate: false,
    });

    const [list, setList] = useState([]);

    const [selected, setSelected] = useState([]);

    // Variables defined for Selected Values End
    // Set default value for referrer
    const defaultValue = '1';
    const [selectedreferror, setSelectedreferrer] = useState(defaultValue);

    // const [selectDoctor, setSelectDoctor] = useState(null);

    const [selecteddoctor, setSelectedDoctor] = useState(null);

    const [visible, setVisible] = useState(false);

    const { user = {}, isMobile, dispatch, settings } = useContext(GlobalContext);

    // Access bill -related settings from the context
    let billSetttings = settings?.BILLADD;

    // Access advance -related settings from the context
    const { enableCorporateAdvance,enableGuestAdvance } = settings?.ADVSET || {};

    const [coupon, setCoupon] = useState({});

    const [CouponVisible, setCouponVisible] = useState(false);

    const [doctors, setDoctors] = useState([]);
    const [corporateDetails, setCorporateDetails] = useState([]);

    const [summary, setSummary] = useState({
        total: 0,
        items: [],
    });

    const [payableDetails, setPayableDetails] = useState({
        advancePaidDetails: 0,
        corporatePayable: 0,
        guestPayable: 0,
        netAmount: 0,
    });

    const [roundValue] = useState(2);

    const [btnloading, setBtnloading] = useState(false);

    const [loading, setLoading] = useState(true);

    const [validGender, setValidGender] = useState([]);

    const [alreadyBilledVisible, setAlreadyBilledVisible] = useState(false);

    const [billingSummaryloading, setBillSummaryLoading] = useState(false);

    const [doctorAppointmentId, setDoctorAppointmentId] = useState();

    const [disabled, setDisabled] = useState(false);

    const [doctorAppointment, setDoctorAppointment] = useState();

    const [couponDetails, setCouponDetails] = useState(false);

    const [billDiscount, setBillDiscount] = useState(0);

    const [itemDiscount, setItemDiscount] = useState(0);

    const [addToCollection, setAddToCollection] = useState(false);

    const [createdBillId, setCreatedBillId] = useState(null);

    const [confirmModalBtnLoading, setConfirmModalBtnLoading] = useState(false);

    const [claimAdvance, setClaimAdvance] = useState(false); // For Claim Advance

    const [advanceDetails, setAdvanceDetails] = useState(null); // for show the advance details

    const corporateptr = urlParams.op_corporateptr;

    const mode = urlParams.mode;

    const { t, i18n } = useTranslation(); // To Translate to another language

    let total = 0;

    let subTotal = 0;

    const [guestBalance, setGuestBalance] = useState(0); // for guest balance
    const [corporateBalanace, setCorporateBalance] = useState(0); // for corporate balance

    // for getting currency details

    // Assuming `user` is defined and has the `firm`and f_otherdetails property
    let otherDetails = user.firm.f_otherdetails1;

    let currency = JSON.parse(otherDetails);
    let currencySymbol = currency.currency_symbol;

    // Load all the
    useEffect(async () => {
        // If appointmentId is present in params
        if (params.appointmentId) {
            await getAppointmentDetails(params.appointmentId);
        } else {
            //get Categories
            await getCategories();
        }
        // Get all the bill types
        await getBillTypes();

        // get Referrer list
        await getReferrers();

        //    await getCategory()
    }, []);

    /**
     * Get the bill types
     */
    function getBillTypes() {
        Bills.getBillTypes().then((result) => {
            setTypes(result);
            setSelectedbilltype(result[0].btyp_code);
        });
    }

    /**
     * Get the referrers
     */
    function getReferrers() {
        Referrers.get().then((result) => {
            setReferreroptions(result.result);
        });
    }
    /**
     * get Categories
     * @param {*} category
     */

    function getCategories() {
        Categories.getCategories().then((data) => {
            let value = data.result;
            setCategory(data.result);
            // setCategory(data.result);
            //setSelectedcategory(data.result[0].itmrt_code);)
            // setSelectedcategory(data.result[0].ir_ratecatptr);
            let filter = value.find((e) => e.itmrt_code === 'GEN');
            setSelectedcategory(filter.itmrt_code);

            setLoading(false);
        });
    }

    /**
     * Get appointment and package details
     * @param {*} id
     */
    async function getAppointmentDetails(id) {
        setBillSummaryLoading(true);
        setSelected([]);
        setCoupon(null);
        setCouponDetails(false);
        setDoctorAppointmentId(id);
        const result = await Appointments.getAppointmentDetails(id);
        // if result has corporate pointer , that means corporate selected at the time of apppointment
        // so the billvalue are based on corporate item rate mapping .
        // Then we set billvalues as rate .
        //
        if (!result.bill_id) {
            // If it's an existing guest  OR New Guest without a bill_id, set the package details
            setSelected(result.packageDetails);

            if (result.corporatePointer) {
                setSelectedCorporate(result.corporatePointer);
                // in appointment have corporater set disable
                disabledfield.disabled_corporate = true;
                setCorporateDetails({ rate: result.billValue });

                let data = result.packageDetails[0];

                // this Function used for fetch category based on corporate
                //There is corporate is present in appointmnt. then we want to load category based on this corporate

                let record = {
                    package_value: data.ir_itemptr,
                    corporate_pointer: result.corporatePointer,
                    type: 'c',
                };
                if (!result?.couponCorporateDetails?.corporate_ptr) {
                    await onCorporateChange(record, result.packageDetails);
                }
            } else {
                // If there is NO corporatePointer in the appointment (i.e., guest is not associated with any corporate):
                // Clear the corporate selection
                setSelectedCorporate('');
                // Enable the corporate select field so the user can manually choose a corporate
                disabledfield.disabled_corporate = false;
            }

            if (result.couponCorporateDetails?.corporate_ptr) {
                setSelectedCorporate(result.couponCorporateDetails?.corporate_ptr);
                disabledfield.disabled_corporate = true;
            }

            // Set the package to summary too
            setSummary({
                items: result.packageDetails,
                guest: summary.guest,
            });
            // setting corporate extra details
            setPayableDetails({
                advancePaidDetails: result?.couponCorporateDetails?.advance_paid_by_corporate,
                corporatePayable: result?.couponCorporateDetails?.corporate_payable,
                guestPayable: result?.couponCorporateDetails?.guest_payable,
            });

            setDoctorAppointment(result);

            // for showing advance details balance
            if (result.advanceDetails) {
                setAdvanceDetails(result.advanceDetails);
                if (result.advanceDetails?.adv_mode === 'CUS') {
                    setCorporateBalance(result.advanceDetails.balance || 0);
                }
            }

            // setSelectedDoctor(result.doctorPointer);
            setCorporate(result?.couponCorporateDetails?.corporate_ptr);

            /**If there is coupon then set it else refferer discount is set */
            if (result?.couponCorporateDetails?.referrer_ptr) {
                setSelectedreferrer(result?.couponCorporateDetails?.referrer_ptr);

                // in appointment have referrer,set disable
                disabledfield.disabled_referrer = true;
            } else if (result && result.referrerPointer) {
                setSelectedreferrer(result.referrerPointer);

                // in appointment have referrer,set disable
                disabledfield.disabled_referrer = true;
            }

            // Disable  corporate and referrer if the coupon is associated with a corporate
            if (result.couponCorporateDetails?.referrer_ptr) {
                setDisableField((prev) => ({ ...prev, disabled_referrer: true }));
            }

            if (result.couponCorporateDetails?.corporate_ptr) {
                setDisableField((prev) => ({ ...prev, disabled_corporate: true }));
            }

            if (result.couponNo) {
                setCouponDetails(true);
                // Set coupon applied for the appointment
                setCoupon({
                    coupon_no: result?.couponNo,
                    coupon_value: result?.couponValue,
                    coupon_amount: result?.couponValue,
                    ...result?.couponCorporateDetails,
                });
            }
        } else {
            // Clear the selected packages
            setSelected([]);
            setCoupon({});
            setCouponDetails(false);
            setPayableDetails({});
            setSelectedreferrer(selectedreferror);
            setRemarks('');
            setCorporateDetails([]);
            setDisableField({
                setSelectedreferrerdisabled_referrer: false,
                disabled_corporate: false,
            });
            setCorporate('');
            setSelectedCorporate('');
            setSelectedcategory('GEN');
        }

        setBillSummaryLoading(false);
        setLoading(false);
    }

    /**
     *
     * @param {*} values
     * @returns
     */
    const createBill = async ({ verified }) => {
        setBtnloading(true);
        setValidGender([]);

        // Check if the gender for the items selected match with gender of the customer
        await Promise.all(
            summary.items.map((ele) => {
                const genderValidity = Opreg.validateGender(guest.op_gender, ele.itm_gender);
                validGender.push(genderValidity);
            })
        );

        // If gender is not valid return error
        if (validGender && validGender.indexOf(false) !== -1) {
            message.error('The Selected Gender does not match with the Selected Package Gender. Please Select the Correct Gender');
            setBtnloading(false);
            return false;
        }
        var formBody = {
            op_no: params.op_no,
            opb_opno: params.op_no,
            visit_id: '',
            // opbd_itemptr: params.da_packagetypevalue,
            rate_type: '3', // Not sure if required
            opd_remarks: remarks,
            // opd_corporateptr: "12",
            category: selectedcategory,

            billtype: selectedbilltype,

            // cmgdcpn_couponnumber: coupon.coupon_no,

            doctorptr: selecteddoctor,

            Bdiscount_amt: discount,

            refererptr: selectedreferror,

            // corporate: selectedCorporate,

            appointmentId: params.appointmentId || doctorAppointmentId,
        };

        // if disount type is percentage return percentage
        if (discount && discount.type === '%') {
            formBody.discountPercentage = discount.value;
        } else if (discount && discount.type === currencySymbol) {
            // If discount type is amount return amount
            formBody.discountAmount = discount.value;
        }

        // // If coupon is applied return coupon
        // if (coupon && coupon.coupon_no) {
        //     formBody.couponNo = coupon.coupon_no;
        // }

        // If verified is true(when the create bill, is triggered but a bill with same opnumber and date is present in opbills and the customer has approved for fuether billing)
        if (verified) {
            formBody.verified = true;
        }

        if (buttonEnable) {
            formBody = {
                ...formBody,
                name: guest.op_fname,
                age: guest.op_age,
                ageType: guest.op_agetype,
                mobile: guest.op_mobile,
                gender: guest.op_gender,
            };
        }

        if (summary && summary.guest) {
            summary.guest.corporate = selectedCorporate;
            formBody = {
                ...formBody,
                ...summary.guest,
            };
        }

        if (summary.guest && summary.guest.op_number) {
            formBody = {
                ...formBody,
                op_no: summary.guest.op_number,
            };
        }

        if ((discount.value && discount.value != 0) || (coupon && coupon.coupon_no && coupon.coupon_value)) {
            if (!formBody.opd_remarks) {
                message.error('Please Enter Remarks');
                setBtnloading(false);
                return false;
            }
        }

        // If coupon is applied during appointment, couponno is not send to api
        if (doctorAppointment && doctorAppointment.couponNo) {
            delete formBody.couponNo;
        }

        // Check if the summary contains guest information
        // This is the direct bill case

        if (summary?.guest && summary?.guest?.doctorAppointment) {
            // Determine if the guest has a doctor appointment by checking items in the summary
            const hasDoctorAppointment = summary.items.some((item) => item.ir_itemptr === summary.guest.doctorAppointment.packagetypevalue);

            // If there is no doctor appointment present  and a coupon exists, reset the coupon
            if (!hasDoctorAppointment && coupon && coupon.coupon_no) {
                formBody.couponNo = coupon.coupon_no; // Reset coupon to the existing coupon number
            } else {
                // If coupon is applied during appointment, couponno is not send to api
                // Check if a doctor appointment exists and if a coupon number is associated with that appointment
                if (doctorAppointment && doctorAppointment.couponno) {
                    // If a coupon is applied during the appointment, remove the coupon number from the form body to avoid sending it to the API
                    delete formBody.couponNo;
                } else if (coupon && coupon.coupon_no) {
                    formBody.couponNo = coupon.coupon_no;
                }
            }
        } else {
            // Normal Billing case
            // If there is no guest, check if a coupon is applied or can be applied
            if (coupon && coupon.coupon_no && !doctorAppointment.couponno) {
                // If a coupon is present and not already applied to the doctor appointment, include it in the request
                formBody.couponNo = coupon.coupon_no; // Add the coupon number for the API request
            }
        }

        // // If coupon is applied return coupon
        // if (coupon && coupon.coupon_no && !doctorAppointment.couponno) {
        //     formBody.couponNo = coupon.coupon_no;
        // }
        // If the the applied coupon has corporatePayable and guestPayable we have to send both to the billing api
        if (
            payableDetails &&
            (Number(payableDetails.advancePaidDetails) >= 0 ||
                Number(payableDetails.corporatePayable) >= 0 ||
                Number(payableDetails.guestPayable) >= 0)
        ) {
            formBody = {
                ...formBody,
                advApplied: claimAdvance,
                ...(!claimAdvance &&
                    (payableDetails.advancePaidDetails > 0 || payableDetails.corporatePayable > 0 || payableDetails.guestPayable > 0) && {
                        advMode: advanceDetails?.adv_mode || null,
                        advAmount: payableDetails.advancePaidDetails,
                        corpAdvAmount: payableDetails.advancePaidDetails,
                        corpAmount: payableDetails.corporatePayable,
                        patAmount: payableDetails.guestPayable,
                    }),
            };
        }

        // if the corporate is present and there is no corporate mapped to the coupon applied then want to sent rate as corporate rate
        if (corporateDetails && corporateDetails.rate && !coupon?.corporate_ptr) {
            summary.items[0].ir_rate = corporateDetails.rate;
        }
        Bills.createBill(formBody, summary, guest, selectedCorporate, discount, coupon, subTotal, currencySymbol)

            .then((result) => {
                if (result) {
                    if (result.success === false) {
                        setBtnloading(false);
                        message.error('Sorry, The Bill Creation is Failed');
                        return false;
                    }
                    // If there is a bill for the dsame op number in same date, make sure that the customer wants to proceed
                    if (result.billed_today) {
                        setAlreadyBilledVisible(true);
                        return false;
                    }

                    let opbd_hdrid = result.OpBillD[0].opbd_hdrid;
                    setCreatedBillId(opbd_hdrid);

                    message.success('Bill has been successfully created');

                    // if (selectedbilltype === '0') {

                    //     Location.navigate({ method: 'replace', url: `/collections/create?opbd_hdrid=${opbd_hdrid}` })

                    //     // history.push('create/collections')
                    //     // Location.navigate({
                    //     //     method: 'push', url: `/collections`
                    //     // })

                    // } else {
                    //  If "Add to Collection" is checked and bill type is Credit (selectedbilltype === '0'),
                    // navigate  to open Collection Add modal
                    if (addToCollection && selectedbilltype === '0') {
                        Location.navigate({
                            method: 'replace',
                            url: `/order/${opbd_hdrid}?addToCollection=true`,
                        });
                    } else {
                        if (order) Location.navigate({ method: 'replace', url: '/order/' + opbd_hdrid });
                        else Location.navigate({ method: 'replace', url: '/bill/' + opbd_hdrid });

                        // }
                    }

                    setBtnloading(false);
                }
            })
            .catch((result) => {
                setBtnloading(false);

                message.error(JSON.stringify(result.message));
            });
    };

    summary.items = summary.items.map((entry) => {
        // Callback Function
        entry.callback = (props) => {
            // While preparing data we prepare discount object
            entry.discount = {
                ...props,
            };

            // setEntries(items);
        };

        entry.quantity = 1;

        entry.amount = entry.ir_rate * entry.quantity;

        total = total + entry.amount;

        // Row level discount is saved in each record
        const { discount, amount } = entry;

        // var final = amount;
        if (discount) {
            if (discount.type && discount.type.trim() === '%') {
                total = total - (amount * discount.value) / 100;
            } else {
                total = total - discount.value;
            }
        }

        return entry;
    });

    // This condition will be true in two scenarios:
    // * during corporate on change
    //* Condition checkes corporate pointer is present at appointment and no corporate mapped to the coupon applied
    if (corporateDetails && corporateDetails.rate && !coupon?.corporate_ptr) {
        subTotal = corporateDetails.rate;
        total = subTotal;
    } else {
        // Find the total of the items
        summary.total = total;

        subTotal = total;
    }

    // coupon level discount if applied
    if (guest && guest.drAppointment && guest.drAppointment.da_couponno) {
        total = total - guest.drAppointment.da_couponvalue;
    } else if (coupon && coupon.coupon_value && coupon.coupon_no) {
        if (total >= coupon.coupon_value) total = total - coupon.coupon_amount;
        else {
            setCoupon();
            onUpdateCoupon({});
        }
    }

    // Bill level discount if applied
    if (discount) {
        if (discount.type && discount.type.trim() === '%') {
            total = total - (total * discount.value) / 100;
        } else if (discount.type && discount.type.trim() === currencySymbol.trim()) {
            if (discount.value <= subTotal) total = total - discount.value;
            else {
                setDiscount({});
                onUpdate({});
            }
        }
    }

    useEffect(() => {
        loadData();
        getDoctors();
    }, []);

    /**
     * Get all the packages
     */
    const getDoctors = () => {
        return Items.getDoctorsList().then((result) => {
            setDoctors(result.result);

            return result;
        });
    };

    function loadData() {
        var params = Location.search();
        getCustomers();

        //For direct flow we dont need opReg data
        if (!buttonEnable) {
            getOpRegData(params.op_no);
        }

        // getOPReg(params.op_no)
    }

    /**
     *
     */
    // function getOPReg(id) {
    //     Registrations.getOpregDetail(id).then((result) => {
    //         setGuest(result);
    //         getGuestAge(result);
    //         // setGuestAge(age);
    //     });
    // }
    function getOperg(op_no, da_id) {
        if (op_no) {
            Bills.getOperg(op_no, da_id).then((result) => {
                setGuest(result.data);
            });
        } else {
            setGuest([]);
        }
    }

    // Function to fetch payable details
    const fetchPayableDetails = async () => {
        const payload = {
            net_amount: total,
            code: {
                opNo: guest?.op_no ?? null,
                corporatePtr: selectedCorporate ? selectedCorporate : corporate ?? null,
            },
            // guest_payable: payableDetails.guestPayable || 0,
            // corporate_payable: payableDetails.corporatePayable || 0,
        };

        //API
        const res = await Bills.getPayableDetails(payload);

        // update state with API response
        if (res?.success) {
            setPayableDetails((prev) => ({
                ...prev,
                advancePaidDetails: res?.data?.advance_paid ?? prev.advancePaidDetails,
                corporatePayable: res?.data?.corporate_payable ?? prev.corporatePayable,
                guestPayable: res?.data?.guest_payable ?? prev.guestPayable,
                netAmount: res?.data?.netAmount ?? prev.netAmount,
            }));
        } else {
            setPayableDetails({
                advancePaidDetails: 0,
                corporatePayable: 0,
                guestPayable: 0,
                netAmount: 0,
            });
        }
    };

    // Claim handler function
    const handleClaimAdvance = async (e) => {
        const checked = e.target.checked;

        if (checked && !total) {
            return;
        }


         // Check if advance is actually allowed
        const guestAllowed = enableGuestAdvance && (guestBalance > 0);
        const corporateAllowed = enableCorporateAdvance && (corporateBalanace > 0);

        // If user tries to enable but neither is available or allowed
        if (checked && !guestAllowed && !corporateAllowed) {
            return; // block action, nothing to claim
        }

        setClaimAdvance(checked);

        if (checked) {
            await fetchPayableDetails();
        } else {
            setPayableDetails({
                advancePaidDetails: 0,
                corporatePayable: 0,
                guestPayable: 0,
                netAmount: 0,
            });
        }
    };

    async function getOpRegData(op_no) {
        await Bills.getOpRegData(op_no).then(async (result) => {
            if (
                (result.result && result.result[0].op_referrerptr) ||
                !doctorAppointment?.couponCorporateDetails?.referrer_ptr ||
                !doctorAppointment.referrerPointer
            ) {
                // await setSelectedreferrer(result.result[0].op_referrerptr);
                // opreg have  referrer set disable
                // disabledfield.disabled_referrer = true;
            }
            await setGuest(result.result[0]);
        });
    }

    /**
     * Get Customers
     */
    function getCustomers() {
        Bills.getCustomers().then((result) => {
            setList(result.result);
        });
    }

    /**
     *
     */
    function editDetails() {
        Location.navigate({
            url: `/new-registration/guest?da_id=${guest.drAppointment.da_id}&da_packagetypevalue=${guest.drAppointment.da_packagetypevalue}&prereg_id=${guest.drAppointment.da_referenceid}&prereg_opno=${guest.op_no}&mode=${mode}&edit=true&redirect=bill`,
        });
    }

    function onUpdate(values) {
        setDiscount(values);
        setRemarks(values.remarks);
    }

    function onUpdateCoupon(values) {
        let couponAmount;
        // If coupon type is percentage
        if (values.value_type === 'P') couponAmount = subTotal * (values.coupon_value / 100);
        // If coupon type is amount
        else if (values.value_type === 'A') couponAmount = values.coupon_value;
        values = {
            ...values,
            coupon_amount: couponAmount,
        };
        setCoupon({
            coupon_amount: values?.coupon_value,
            ...values,
        });
        if (values && values.remarks) setRemarks(values.remarks);
    }

    function onUpdateRemarks(event) {
        setRemarks(event.target.value);
    }

    /**
     * Select Doctor onchange of doctor
     * @param {*} value
     */
    const selectDoctor = (value) => {
        setSelectedDoctor(value);
    };

    /**
     * On change of Category items should update its values
     * @param {*} value
     */

    async function UpdateCategory(record) {
        // setSelectedcategory(value)
        setAlert(true);
        setItemRateData(record);

        // var arr = [];
        // var categoryChange = true;
        // if (selected.length) {
        //     Promise.all(
        //         selected.map(async (ele) => {
        //             if (ele && ele.itm_code) var newItem = await getItems(ele.itm_code, value, categoryChange);

        //             if (newItem) arr.push({ ...newItem });
        //             return arr;
        //         })
        //     ).then((arr) => {
        //         setSelected(arr[0]);
        //     });
        // }
    }

    /**
     * Get the master data to show options for the user
     */
    // async function getItems(defaultItem, category, categoryChange) {
    //     setLoading(true);

    //     return await Items.getItems(defaultItem, category).then(async (result) => {
    //         // result = result.map((ele) => {
    //         //     return {
    //         //         ...ele,
    //         //         ir_rate: ele.itemrate[0].ir_rate,
    //         //         ir_itemptr: ele.itemrate[0].ir_itemptr,
    //         //     };
    //         // });

    //         if (categoryChange) {
    //             setLoading(false);

    //             return result[0];
    //         } else {
    //             setMaster(result);

    //             setSelected([result]);

    //             setLoading(false);
    //         }
    //     });
    // }

    const onUpdateSelect = (value, updateMethod) => {
        if (value) {
            updateMethod(value);
        } else {
            updateMethod('');
        }
    };

    // const updatedCorporate = {
    //     ...corporate,
    //     corporate: record.cc_styledcontent,

    //   };
    function onCandidateSelect(guest) {
        summary.guest = guest;

        setGuest(guest);

        if (guest && guest.doctorAppointment) getAppointmentDetails(guest.doctorAppointment.id);
    }
    /**
     *  When Coupon applied from Bills .then want to check coupon is applicable for specific item
     */
    let packageValue;

    if (summary.items.length > 0) {
        packageValue = summary.items[0].ir_itemptr;
    }

    /**
     * Item Rate mapping .
     * This function triggered two scenario
     * * corporate on Change
     * * Category on Change
     * @param {*} record
     */

    async function onCorporateChange(record, selected) {
        const value = record.corporate_pointer;
        // Only fetch referrer if enableCorporateReferrerMap is true
        if (enableCorporateReferrerMap) {
            // Fetch the referrer mapping based on the customer information
            // if(value){
            let referrer = await Items.getCorporateReferrerMapping(value);
            // }

            if (referrer && referrer.id) {
                setSelectedreferrer(referrer.id); // Set the referrer in state
                // corporate mapped with referrer set disable
                disabledfield.disabled_referrer = true;
            } else {
                // setSelectedreferrer(null);
                //    not mapped set enable
                disabledfield.disabled_referrer = false;
            }
            // form.setFieldsValue({ camp_site: corporateReferrer }); // Set the camp_site field
        }

        let values;
        // itemratemapping based on selected corporate
        let pacakgeValues = [];
        if (selected && selected.length > 0) {
            setSelectedcategory(record);

            // selecting package values from selected arry
            selected.forEach((ele) => {
                let package_value = ele.itm_code;
                pacakgeValues.push(package_value);
            });

            // here pacakage value is array of item code
            record = {
                ...record,
                package_value: pacakgeValues,
            };

            // Only fetch referrer if enableCorporateReferrerMap is true
            if (enableCorporateReferrerMap) {
                // Fetch the referrer mapping based on the customer information
                // if(value){
                let referrer = await Items.getCorporateReferrerMapping(value);
                // }

                if (referrer && referrer.id) {
                    setSelectedreferrer(referrer.id); // Set the referrer in state
                    // corporate mapped with referrer set disable
                    disabledfield.disabled_referrer = true;
                } else {
                    // setSelectedreferrer(null);
                    //    not mapped set enable
                    disabledfield.disabled_referrer = false;
                }
                // form.setFieldsValue({ camp_site: corporateReferrer }); // Set the camp_site field
            }

            let response = await Items.getItemRateMapping(record);

            // if the corperate is selected then want to set bill value
            if (response.success && response.data.every((item) => item != null)) {
                values = response.data;
                setCorporateDetails(values);
                setAdvanceDetails(response.advanceDetails);
                if (response.advanceDetails?.adv_mode === 'CUS') {
                    setCorporateBalance(response.advanceDetails.balance || 0);
                } else {
                    setCorporateBalance(0);
                }

                let selectedData = [];
                /// set rate and discount to the selected state
                await selected.forEach((element) => {
                    let filter = values.filter((item) => item.item_pointer == element.itm_code);

                    let rate = filter[0].rate;
                    // if there is discount then  we  set discount and item rate based on discount
                    if (filter[0].discount) {
                        // element.ir_rate = rate;

                        //  set item rate  based on discount
                        element.ir_rate = filter[0].item_rate;

                        element.discount = { value: filter[0].discount, type: currencySymbol };
                        //  element.amount = rate
                    } else {
                        element.ir_rate = rate;
                        // element.amount = rate
                        element.discount = null;
                    }

                    selectedData.push(element);
                });

                setSelected(selectedData);
                // set selected catogory if the corporate is present
                if (values[0].category_ptr) {
                    setSelectedcategory(values[0].category_ptr);
                } else {
                    setSelectedcategory('GEN');
                }
                setSelectedCorporate(value);
            } else {
                setSelectedcategory('GEN');
            }
        }

        if (value === 'GEN') {
            setSelectedCorporate('');
        } else {
            setSelectedCorporate(value);
        }
    }

    /**
     *
     * This Function is used for fetch category based on corporate
     * @param {*} record .
     *
     */

    function getCategory(record) {
        Categories.getCategory(record).then((result) => {
            if (result.success) {
                let value = result.data;
                setSelectedcategory(value.category_code);
            } else {
                // getCategories();
                setSelectedcategory('GEN');
            }
        });
    }

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setAddToCollection(checked);
        // if (checked) {
        //   setIsModalOpen(true);
        // }
    };

    const fetchAppointments = async () => {
        const opNumber = guest?.op_number || guest?.op_no;

        if (opNumber) {
            try {
                const res = await Appointments.getDoctorAppointment(opNumber);
                if (res.success) {
                    if (res.advanceDetails) setAdvanceDetails(res.advanceDetails);

                    if (res.advanceDetails?.adv_mode === 'GUEST') {
                        setGuestBalance(res.advanceDetails.balance || 0);
                    }
                }
            } catch (err) {
                console.error('Error fetching appointments:', err);
            }
        }
    };

    useEffect(() => {
        fetchAppointments();
    }, [guest, selected]);

    // Function to calculate the final balance
    const getFinalBalance = () => {
        const guest = guestBalance ?? 0; 
        const corporate = corporateBalanace ?? 0; 
        if (enableGuestAdvance && !enableCorporateAdvance) {
            return guest; 
        } else if (!enableGuestAdvance && enableCorporateAdvance) {
            return corporate; 
        } else if (enableGuestAdvance && enableCorporateAdvance) {
            return guest + corporate; 
        }
        return 0;
    };

    // Add this useEffect after other useEffect declarations
    useEffect(() => {
        // Check if items are selected and there's an advance balance
        if (selected?.length > 0 && advanceDetails?.balance) {
            // Auto trigger claim advance handler
            handleClaimAdvance({ target: { checked: true } });
        }
    }, [selected, advanceDetails]);

    useEffect(() => {
        const fetchCorporateBalance = async () => {
            if (!selectedCorporate) {
                setCorporateBalance(0);
                if (advanceDetails?.adv_mode === 'CUS') {
                    setAdvanceDetails(null);
                }
                return;
            }
            try {
                const showCorporateBalance = await Customers.getCorporateDetails(selectedCorporate);

                if (showCorporateBalance.advanceDetails && showCorporateBalance.advanceDetails.adv_mode === 'CUS') {
                    setAdvanceDetails(showCorporateBalance.advanceDetails);
                    setCorporateBalance(showCorporateBalance.advanceDetails.balance || 0);
                } else {
                    setCorporateBalance(0);
                    if (advanceDetails?.adv_mode === 'CUS') {
                        setAdvanceDetails(null);
                    }
                    if (!showCorporateBalance.advanceDetails) {
                        fetchAppointments();
                    }
                }
            } catch (error) {
                console.error('Error fetching corporate balance:', error);
            }
        };

        fetchCorporateBalance();
    }, [selectedCorporate, selected]);

    return (
        <div className="bill-summary">
            {/* <div className="page-header">
                <Title className="title" level={4}>
                    {t('BILL SUMMARY')}
                </Title>

                <div className="top-actions">
                    <Button size={'small'} type="secondary" onClick={loadData}>
                        {t('Refresh')}
                    </Button>
                </div>
            </div> */}

            <div></div>
            {loading ? (
                <Card className="">
                    <Skeleton />
                </Card>
            ) : (
                <div className="bill-content">
                    <Card className="bill-items card form card-shadow">
                        <div className="form-content">
                            {/* Item Selection Component */}
                            <div className="top-section">
                                <div className="summary-bottom" style={{ width: '30%' }}>
                                    <div className="right">
                                        <Title level={5}>{t('Category')}</Title>

                                        <ReferenceSelect
                                            label="itmrt_desc"
                                            value={selectedcategory}
                                            mode="nura-base"
                                            config={{
                                                queries: [
                                                    {
                                                        field: 'itmrt_active',

                                                        value: 'Y',
                                                    },
                                                ],
                                            }}
                                            // onChange={UpdateCategory}
                                            onChange={(entry) => {
                                                let record = {
                                                    category_pointer: entry,
                                                    // package_value: summary.items[0].ir_itemptr,
                                                };

                                                UpdateCategory(entry, record);
                                            }}
                                            model={ItemRateTypes}
                                            field={'itmrt_code'}
                                        />
                                    </div>
                                </div>
                                <div className="summary-bottom" style={{ width: '20%' }}>
                                    <div className="right">
                                        <Title level={5}>{t('Bill Types')}</Title>
                                        <Select
                                            style={{ marginLeft: '5px', marginRight: '5px', width: '100%' }}
                                            onChange={(entry) => onUpdateSelect(entry, setSelectedbilltype)}
                                            value={selectedbilltype}
                                            // style={{ width: '100%' }}
                                            placeholder={t('Choose Bill Type')}
                                        >
                                            {types.map((item, key) => (
                                                <Option key={key} value={item.btyp_code}>
                                                    {item.btyp_caption}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                                <div className="summary-bottom" style={{ width: '20%' }}>
                                    <div className="right">
                                        <Title level={5}>{t('Referrer')}</Title>
                                        <Select
                                            value={selectedreferror}
                                            onChange={(entry) => onUpdateSelect(entry, setSelectedreferrer)}
                                            allowClear
                                            // labelInValue={true}
                                            style={{ width: '100%' }}
                                            // If guest is billed , then  enable
                                            // Otherwise, use the 'disabled_referrer' value from 'disabledfield'

                                            disabled={doctorAppointment?.bill_id ? false : disabledfield.disabled_referrer}
                                            placeholder={t('Choose Campaign')}
                                            showSearch
                                            optionFilterProp="children" //  Select to filter by the text inside Option
                                            filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
                                        >
                                            {referreroptions.map((item, key) => (
                                                <Option key={key} value={item.refr_code}>
                                                    {item.refr_desc}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            </div>

                            {/* Component For Billing */}
                            {billingSummaryloading ? (
                                <Skeleton />
                            ) : (
                                <BillSummary
                                    selectedcategory={selectedcategory}
                                    {...props}
                                    defaultItem={defaultItem}
                                    loadData={loadData}
                                    selectedItems={selected}
                                    enableItemDiscount={enableItemDiscount}
                                    // order={order}
                                    buttonEnable={buttonEnable}
                                    currency={currencySymbol}
                                    subTotal={subTotal}
                                    total={total}
                                    payableDetails={payableDetails}
                                    itemDiscount={itemDiscount}
                                    callback={(items, coupon, discount, guestPayable) => {
                                        // if(summary.guest){
                                        //     // Check if the doctor appointment package is present in the selected items
                                        //     const hasDoctorAppointment = items.some(
                                        //         (item) => item.ir_itemptr === summary.guest.doctorAppointment.packagetypevalue
                                        //     );
                                        //     // If package is not present, reset coupon if one exists

                                        //     if (!hasDoctorAppointment && coupon && coupon.coupon_no) {
                                        //         setCoupon();
                                        //     }
                                        // }

                                        setClaimAdvance(false);
                                        //If the items are removed, the corporate and referrer fields should be enabled
                                        if (items.length == 0) {
                                            subTotal = 0;
                                            total = 0;
                                            if (!guest) {
                                                setSelectedreferrer(defaultValue);
                                                setCorporate(null);

                                                setPayableDetails({});
                                                setCorporateDetails([]);
                                                setDisableField({
                                                    setSelectedreferrerdisabled_referrer: false,
                                                    disabled_corporate: false,
                                                });
                                                setCorporate('');
                                                setSelectedCorporate('');
                                                setSelectedcategory('GEN');
                                            } else {
                                                if (!guest.op_corporateptr) {
                                                    setDisableField((prev) => ({
                                                        ...prev, // Preserve previous values
                                                        disabled_corporate: false,
                                                    }));
                                                }
                                                if (!guest.op_referrerptr) {
                                                    setDisableField((prev) => ({
                                                        ...prev, // Preserve previous values
                                                        disabled_referrer: false,
                                                    }));
                                                }
                                            }

                                            setCouponDetails(false);
                                            setCoupon({});
                                            setPayableDetails({});
                                            setSelectedreferrer(selectedreferror);
                                            setRemarks('');
                                            setSelected(items);
                                            setCorporateDetails([]);
                                            setDisableField({
                                                setSelectedreferrerdisabled_referrer: false,
                                                disabled_corporate: false,
                                            });
                                            setCorporate('');
                                            setSelectedCorporate('');
                                            setSelectedcategory('GEN');
                                        } else {
                                            // setSummary(items);
                                            setSelected(items);
                                            setItemDiscount(discount);
                                            setPayableDetails({ ...payableDetails, guestPayable: guestPayable });
                                            setSummary({
                                                guest: summary.guest,
                                                items: items,
                                                total: 0,
                                            });
                                        }
                                    }}
                                />
                            )}
                        </div>
                    </Card>

                    {/* </div> */}

                    {/* guest Information component */}
                    <div className="bill-part">
                        <GuestInformation
                            showWalletDetails={showWalletDetails}
                            enableGuest={props.enableGuest}
                            buttonEnable={true}
                            callback={onCandidateSelect}
                            getReferrer={getOpRegData}
                            doctorAppointment={doctorAppointment}
                            disableGuestEdit={selected.length > 0}
                        />

                        {/* Corporate Selection Component */}
                        <CorporateSection
                            value={corporate}
                            selectedCorporate={selectedCorporate}
                            corporate={corporate}
                            setCorporate={setCorporate}
                            packageValue={summary}
                            disableCorporate={disableCorporate || disabledfield.disabled_corporate}
                            callback={(values, record) => {
                                if (values.package_value) {
                                    setAlert(true);
                                    setItemRateData(values);
                                } else {
                                    getCategory(values);
                                    onCorporateChange(values, selected);
                                }
                            }}
                        />

                        <Coupon
                            visible={couponDetails}
                            couponDetails={coupon}
                            currency={currency}
                            isSuccess={couponDetails}
                            showInfoIcon={couponDetails}
                        />
                        {/* Corporate Selection Component Ends */}

                        <Card className="right-part card card-shadow">
                            <div className="bill-summary-bottom">
                                <div className="sub-section">
                                    <Title level={5}>{t('BILL DETAILS')}</Title>
                                    <div
                                        className="section-row"
                                        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap' }}
                                    >
                                        <div className="section-label">
                                            <Text type="secondary">{t('SUB TOTAL')}</Text>
                                        </div>
                                        <div className="section-value">
                                            <strong>
                                                {/* <Rupee value={parseFloat(subTotal.toFixed(roundValue))}></Rupee> */}
                                                {/* {formatCurrency(parseFloat(subTotal.toFixed(roundValue)), currencySymbol)} */}

                                                {selected && selected.length && selected.length > 0 ? (
                                                    <PriceFormatter
                                                        price={parseFloat(subTotal.toFixed(roundValue))}
                                                        locale={currency.priceFormat}
                                                        currency={currency.currency_code}
                                                        enablePriceFormatting={currency.enablePriceFormatting}
                                                    />
                                                ) : null}
                                            </strong>
                                        </div>
                                    </div>
                                    {/* {console.log(selected)} */}
                                    {selected && selected.length && selected.length > 0 ? (
                                        disableBillDiscount === true ? null : (
                                            <>
                                                <div className="section-row" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                                                    <div className="section-label">
                                                        <Text type="secondary">{t('DISCOUNT')}</Text>
                                                    </div>
                                                    {discount && discount.type ? (
                                                        <div className="section-value">
                                                            <strong>
                                                                {discount && discount.type === currencySymbol ? discount.type : null}{' '}
                                                                {discount && discount.value ? discount.value : 0}{' '}
                                                                {discount && discount.type === '%' ? discount.type : null}
                                                            </strong>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <Button
                                                                style={{ padding: '0' }}
                                                                className="bill-discount-button"
                                                                size="small"
                                                                type="link"
                                                                onClick={() => {
                                                                    setVisible(true);
                                                                }}
                                                            >
                                                                {t('APPLY DISCOUNT')}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>

                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    {discount && discount.type ? (
                                                        <Button
                                                            style={{ padding: '0' }}
                                                            className="cancel-coupon-button"
                                                            size="small"
                                                            type="text"
                                                            onClick={() => {
                                                                setDiscount({});
                                                                onUpdate({});
                                                                // Setting coupon extra details after cancelling the bill discount applied
                                                                let guestPayable = payableDetails.guestPayable + billDiscount;
                                                                setPayableDetails({
                                                                    ...payableDetails,
                                                                    guestPayable: guestPayable,
                                                                });
                                                            }}
                                                        >
                                                            <span className="disc-btn">{t('Remove')}</span>
                                                        </Button>
                                                    ) : null}
                                                </div>
                                            </>
                                        )
                                    ) : null}

                                    {selected && selected.length && selected.length > 0 ? (
                                        disableBillCoupon === true ? null : (
                                            <>
                                                {guest && guest.drAppointment && guest.drAppointment.da_couponvalue ? (
                                                    <>
                                                        <div className="section-row">
                                                            <div className="section-label">
                                                                <Text type="secondary">{t('COUPON DISCOUNT')}</Text>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div
                                                            className="section-row"
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'space-between',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            <div className="section-label">
                                                                <Text type="secondary">{'COUPON DISCOUNT'}</Text>
                                                            </div>
                                                            {coupon && coupon.coupon_no ? (
                                                                <>
                                                                    {/* <Alert message={validMessage}description={coupon.cmgdcpn_remarks} />  */}
                                                                    <div>
                                                                        {/* <div className="section-value">
                                                                            <strong>{coupon.coupon_amount}</strong>
                                                                        </div> */}
                                                                        <PriceFormatter
                                                                            price={coupon.coupon_amount}
                                                                            locale={currency.priceFormat}
                                                                            currency={currency.currency_code}
                                                                            enablePriceFormatting={currency.enablePriceFormatting}
                                                                            color="green"
                                                                            sign="-"
                                                                        />
                                                                        <Button
                                                                            style={{ marginLeft: '10px', padding: '0' }}
                                                                            className="cancel-coupon-button"
                                                                            size="small"
                                                                            type="text"
                                                                            onClick={() => {
                                                                                // reset corporate value
                                                                                if (coupon.corporate_ptr) {
                                                                                    setCorporate(null);
                                                                                }
                                                                                // reset refferer set default value
                                                                                if (coupon.referrer_ptr) {
                                                                                    setSelectedreferrer(defaultValue);
                                                                                }
                                                                                // if(coupon)
                                                                                setCoupon(null);
                                                                                setRemarks('');
                                                                                setCouponDetails(false);
                                                                                setPayableDetails({
                                                                                    advancePaidDetails: 0,
                                                                                    corporatePayable: 0,
                                                                                    guestPayable: 0,
                                                                                });
                                                                            }}
                                                                        >
                                                                            {/**If coupon is applied from appointemnt, removing of coupon is not supported */}
                                                                            {doctorAppointment && doctorAppointment.couponNo ? null : (
                                                                                <span className="coup-btn">{t('Remove')}</span>
                                                                            )}
                                                                        </Button>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div>
                                                                    <Button
                                                                        style={{ padding: '0' }}
                                                                        className="add-coupon-button"
                                                                        size="small"
                                                                        type="link"
                                                                        onClick={() => {
                                                                            setCouponVisible(true);
                                                                        }}
                                                                    >
                                                                        {t('APPLY COUPON')}
                                                                    </Button>

                                                                    <strong>{coupon && coupon.coupon_no ? coupon.coupon_amount : null}</strong>
                                                                </div>
                                                            )}

                                                            {/* <div className="section-value"> */}
                                                            {/* {coupon && coupon.dataValues ? coupon.dataValues.cmgdcpn_couponnumber : null}  */}

                                                            {/* <strong>{coupon ? coupon.coupon_value : 0}</strong>
                                            </div> */}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )
                                    ) : null}

                                    {/* Claim Advance */}
                                    {selected && selected.length > 0 && advanceDetails?.balance ? (
                                        <div
                                            className="section-row"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <div className="section-label">
                                                <Text type="secondary">{t('AVAILABLE ADVANCE')}</Text>
                                            </div>

                                            <div className="section-value">
                                                <PriceFormatter
                                                    // price={
                                                    //     claimAdvance
                                                    //         ? Math.max(advanceDetails.balance - total, 0) // deduct total from balance
                                                    //         : advanceDetails.balance
                                                    // }
                                                    price={getFinalBalance()}
                                                    locale={currency.priceFormat}
                                                    currency={currency.currency_code}
                                                    enablePriceFormatting={currency.enablePriceFormatting}
                                                />
                                            </div>
                                        </div>
                                    ) : null}

                                    {selected && selected.length > 0 && advanceDetails?.balance ? (
                                        <div className="section-row">
                                            <Popconfirm
                                                title={t('Are you sure you want to continue?')}
                                                okText={t('Yes')}
                                                cancelText={t('No')}S
                                                onConfirm={() => handleClaimAdvance({ target: { checked: !claimAdvance } })}
                                            >
                                                <Checkbox checked={claimAdvance} onClick={(e) => e.preventDefault()} disabled={getFinalBalance()===0} >
                                                    {t('CLAIM ADVANCE')}{' '}
                                                </Checkbox>
                                            </Popconfirm>
                                        </div>
                                    ) : null}
                                    {/* <div className="section-row">
                                        <div className="section-label">
                                            <Text type="secondary">Discount Amount</Text>
                                        </div>
                                        <div className="section-value">
                                            {discount && discount.type == '%' ? (
                                                <strong> {parseFloat(((subTotal * discount.value) / 100).toFixed(roundValue))}</strong>
                                            ) : (
                                                <strong>{discount.value}</strong>
                                            )}
                                        </div>
                                    </div> */}
                                </div>
                                {/* Discount Section Ends */}

                                <hr className="hr-line"></hr>
                                {/* Net Amount */}
                                <div className="section-row net-amount">
                                    <div className="section-label">
                                        <Title level={5}>{t('Net Amount')}</Title>
                                    </div>
                                    {selected && selected.length && selected.length > 0 ? (
                                        <PriceFormatter
                                            price={parseFloat(total.toFixed(roundValue))}
                                            locale={currency.priceFormat}
                                            currency={currency.currency_code}
                                            enablePriceFormatting={currency.enablePriceFormatting}
                                        />
                                    ) : null}
                                </div>
                                <hr className="hr-line"></hr>
                                {payableDetails &&
                                (payableDetails.advancePaidDetails || payableDetails.corporatePayable || payableDetails.guestPayable) &&
                                advanceDetails?.balance ? (
                                    <>
                                        {enableAdvance ? (
                                            <div
                                                className="section-row"
                                                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap' }}
                                            >
                                                <div className="section-label">
                                                    <Text type="secondary">{t('ADVANCE USED')}</Text>
                                                </div>
                                                <div className="section-value">
                                                    <strong>
                                                        <PriceFormatter
                                                            // price={parseFloat( payableDetails.advancePaidDetails?.toFixed(roundValue))}
                                                            price={
                                                                claimAdvance ? parseFloat(payableDetails.advancePaidDetails?.toFixed(roundValue)) : 0
                                                            }
                                                            locale={currency.priceFormat}
                                                            currency={currency.currency_code}
                                                            enablePriceFormatting={currency.enablePriceFormatting}
                                                            color="green"
                                                            sign="-"
                                                        />
                                                    </strong>
                                                </div>
                                            </div>
                                        ) : null}

                                        {enableCorpPayable ? (
                                            <div
                                                className="section-row"
                                                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap' }}
                                            >
                                                <div className="section-label">
                                                    <Text type="secondary">{t('CORPORATE PAYABLE')}</Text>
                                                </div>
                                                <div className="section-value">
                                                    <strong>
                                                        <PriceFormatter
                                                            price={parseFloat(payableDetails.corporatePayable?.toFixed(roundValue))}
                                                            locale={currency.priceFormat}
                                                            currency={currency.currency_code}
                                                            enablePriceFormatting={currency.enablePriceFormatting}
                                                        />
                                                    </strong>
                                                </div>
                                            </div>
                                        ) : null}
                                        {enablePatientPayable ? (
                                            <div
                                                className="section-row"
                                                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'nowrap' }}
                                            >
                                                <div className="section-label">
                                                    <Title level={5}>{t('GUEST PAYABLE')}</Title>
                                                </div>
                                                <div className="section-value">
                                                    <Title level={5}>
                                                        <PriceFormatter
                                                            price={
                                                                typeof payableDetails.guestPayable === 'number'
                                                                    ? parseFloat(payableDetails.guestPayable.toFixed(roundValue))
                                                                    : 0 // fallback if undefined or not a number
                                                            }
                                                            locale={currency.priceFormat}
                                                            currency={currency.currency_code}
                                                            enablePriceFormatting={currency.enablePriceFormatting}
                                                        />
                                                    </Title>
                                                </div>
                                            </div>
                                        ) : null}
                                    </>
                                ) : null}
                                <div>
                                    <p level={3}>
                                        <strong>{t('REMARKS')}</strong>
                                    </p>

                                    <TextArea value={remarks} maxLength={250} onChange={onUpdateRemarks} placeholder={t('Enter Remarks')}></TextArea>
                                </div>
                            </div>
                        </Card>
                        <Modal
                            destroyOnClose={true}
                            footer={null}
                            title={t('Apply Discount')}
                            visible={visible}
                            okText="Okay"
                            onOk={() => {
                                setVisible(false);
                            }}
                            onCancel={() => {
                                setVisible(false);
                            }}
                        >
                            <DiscountModal
                                callback={(values) => {
                                    let discount = 0;
                                    setVisible(false);

                                    onUpdate(values);
                                    // Getting discount value based on values
                                    if (values.type.trim() === '%') {
                                        discount = (total * values.value) / 100;
                                    } else if (values.type.trim() === currencySymbol.trim()) {
                                        discount = values.value;
                                    }
                                    setBillDiscount(discount);
                                    // Getting guest payable amount after applying bill discount
                                    let guestPayable = payableDetails.guestPayable - discount;

                                    setPayableDetails({
                                        ...payableDetails,
                                        guestPayable: guestPayable,
                                    });

                                    // callback(values);
                                }}
                                discount={discount}
                                subTotal={subTotal}
                                currency={currencySymbol}
                            />
                        </Modal>
                        <Modal
                            destroyOnClose={true}
                            footer={null}
                            title={t('Apply Coupon')}
                            visible={CouponVisible}
                            okText="Okay"
                            onOk={() => {
                                setCouponVisible(false);
                            }}
                            onCancel={() => {
                                setCouponVisible(false);
                            }}
                        >
                            <CouponModal
                                callback={(values) => {
                                    // Disable  corporate and referrer if the coupon is associated with a corporate
                                    if (values.corporate_ptr) {
                                        setCorporate(values.corporate_ptr);
                                        setDisableField((prev) => ({ ...prev, disabled_referrer: true }));
                                    }
                                    if (values.referrer_ptr) {
                                        setSelectedreferrer(values.referrer_ptr);
                                        setDisableField((prev) => ({ ...prev, disabled_corporate: true }));
                                    }
                                    // Set Remarks
                                    setRemarks(`DiscountCoupon:${values.coupon_no}:${values.id}`);
                                    setCouponVisible(false);
                                    setCouponDetails(true);
                                    onUpdateCoupon(values);
                                    setPayableDetails({
                                        advancePaidDetails: values.advance_paid_by_corporate,
                                        corporatePayable: values.corporate_payable,
                                        guestPayable: values.guest_payable,
                                    });
                                    if (values?.corporate_ptr) {
                                        setSelectedCorporate(values?.corporate_ptr);
                                    }
                                    // callback(values);
                                }}
                                setCouponVisible={setCouponVisible}
                                subTotal={subTotal}
                                // item_code={summary.items[0].ir_itemptr}
                                itemCode={packageValue}
                            />
                        </Modal>
                        {/** Modal to confirm that the customer wants to proceed with billing, if there is a bill with same op number and date */}
                        <Modal
                            destroyOnClose={true}
                            // footer={null}
                            title=""
                            visible={alreadyBilledVisible}
                            okText="Okay"
                            confirmLoading={confirmModalBtnLoading} // disables button when true
                            onOk={async () => {
                                if (confirmModalBtnLoading) return; // safeguard in case
                                // add loading state to the button
                                setConfirmModalBtnLoading(true);
                                try {
                                    await createBill({ verified: true });
                                    setAlreadyBilledVisible(false);
                                } finally {
                                    // reset loading state
                                    setConfirmModalBtnLoading(false);
                                }
                            }}
                            onCancel={() => {
                                setBtnloading(false);
                                setAlreadyBilledVisible(false);
                            }}
                        >
                            <p> {t('One or more items for this op number have been billed today. Are you sure you want to proceed?')}</p>
                        </Modal>
                        {/**  Modal to confirm that corporate or category want to change */}
                        <Modal
                            destroyOnClose={true}
                            // footer={null}
                            title=""
                            visible={alert}
                            okText="Okay"
                            onOk={() => {
                                setAlert(false);
                                const corporatePointer = itemRateData.corporate_pointer || 'GEN'; // Default to "GEN" if undefined, null, or ""

                                if (corporatePointer) {
                                    onCorporateChange({ ...itemRateData, corporate_pointer: corporatePointer }, selected);
                                }
                            }}
                            onCancel={() => {
                                setAlert(false);
                                onCorporateChange(itemRateData, null);
                            }}
                        >
                            <p>{t('Do you want to change the selected item rate according to rate category')}</p>
                        </Modal>

                        <Card className="right-part card card-shadow">
                            {enableDoctorSelection && (
                                <div className="summary-bottom">
                                    <div className="right">
                                        <Title level={5}>{t('Select Doctor')}</Title>
                                        <Select
                                            onChange={(entry) => selectDoctor(entry)}
                                            value={selecteddoctor}
                                            disabled={disabled}
                                            style={{ width: '100%' }}
                                            placeholder={t('-Select Doctor-')}
                                        >
                                            {doctors.map((item, key) => (
                                                <Option key={key} value={item.do_code}>
                                                    {item.do_name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            )}
                            <div className="footer-actions">
                                <div className="footers">
                                    {/* add to collections . This checkbox is managed by settings  */}
                                    {selectedbilltype === '0' && billSetttings?.autoCollectionRedirect ? (
                                        <Checkbox onChange={(e) => setAddToCollection(e.target.checked)} checked={addToCollection}>
                                            ADD TO COLLECTIONS
                                        </Checkbox>
                                    ) : null}
                                    <Button
                                        loading={btnloading}
                                        // If items has values and guest is selected
                                        // disabled={!summary.items.length || guest.op_fname}
                                        disabled={
                                            (selected && !selected.length) || (!guest.op_fname && !guest.name && !guest.first_name) || !selected
                                        }
                                        type="primary"
                                        onClick={() => createBill({ verified: false })}
                                    >
                                        {t('Create Bill')}
                                    </Button>
                                </div>
                            </div>

                            {/* Footer Actions Ends */}
                        </Card>
                    </div>
                </div>
            )}
        </div>
    );
}

export default withRouter(BillItems);

/**
 * Component will load the accesories in cart for this booking
 */
function BillSummary({
    selectedcategory,
    callback,
    loadData,
    selectedItems,
    enableItemDiscount,
    currency,
    total,
    subTotal,
    itemDiscount,
    payableDetails,
}) {
    const { t, i18n } = useTranslation(); // To Translate to another language
    useEffect(() => {
        // Load the selected items with the updated price as per the new category
        reviseItemsCategory();
    }, [selectedcategory]);

    function reviseItemsCategory() {
        // If selectedItem is present, item during appointment, set that to selcted array
        if (selectedItems.length > 0) setSelected(selectedItems);
        else setSelected([]);
    }

    const [selected, setSelected] = useState(selectedItems);

    /**
     * Get the master data to show options for the user
     */

    // Note: Ashique - Commented but need to be considered as a quik solution if needed
    // to implement for category change

    // async function getItems(defaultItem, category, categoryChange) {
    //     setLoading(true);

    //     return await Items.getItems(defaultItem, category).then(async (result) => {
    //         // result = result.map((ele) => {
    //         //     return {
    //         //         ...ele,
    //         //         ir_rate: ele.itemrate[0].ir_rate,
    //         //         ir_itemptr: ele.itemrate[0].ir_itemptr,
    //         //     };
    //         // });

    //         if (categoryChange) {
    //             setLoading(false);

    //             return result[0];
    //         } else {
    //             setMaster(result);

    //             setSelected([result]);

    //             setLoading(false);
    //         }
    //     });
    // }

    function onUpdateItemDiscount(values) {
        let discount = 0;
        // Getting discount value based on values
        if (values.type.trim() === '%') {
            discount = (subTotal * values.value) / 100;
        } else if (values.type.trim() === currency.trim()) {
            discount = values.value;
        }

        // Getting guest payable amount after applying item discount
        let guestPayable = payableDetails.guestPayable - discount;

        callback(selected, null, discount, guestPayable);
        // setitmDiscount(values);
    }

    function onDeleteItemDiscount(values) {
        // Setting coupon extra details after cancelling the item discount applied
        let guestPayable = payableDetails.guestPayable + itemDiscount;
        callback(selected, null, null, guestPayable);
    }

    return (
        <div className="item-selection-wrapper">
            {/* Item Selection Component */}
            <ItemSelection
                selectedLabel={t('Selected')}
                includeRate={true}
                category={selectedcategory}
                deleteItem={(index) => {
                    index = index + 1;

                    selected.splice(index);
                }}
                selected={selected}
                callback={(selectedItems) => {
                    setSelected(selectedItems);

                    callback(selectedItems);

                    loadData();
                }}
            />
            {/* Item Selection Component Starts */}
            <>
                {selected && selected.length ? (
                    <SelectedList
                        callback={callback}
                        items={selected}
                        enableItemDiscount={enableItemDiscount}
                        onUpdateItemDiscount={onUpdateItemDiscount}
                        onDeleteItemDiscount={onDeleteItemDiscount}
                        setSelected={setSelected}
                        currency={currency}
                    />
                ) : null}
            </>
        </div>
    );
}

/**
 * On the billing screen , corporate select and
 * its detailed view is seperated as a dedicated component
 *
 * @returns
 */
function CorporateSection({ value, corporate, setCorporate, packageValue, callback, disableCorporate, selectedCorporate }) {
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        setSelected(null);
        if (selectedCorporate) {
            // Fetch all active corporates
            Customers.get({ field: 'cc_active', value: 'Y' }).then((response) => {
                const data = response.result;
                // Find the corporate whose code matches the incoming `selectedCorporate`
                const record = data.find((c) => c.cc_code === selectedCorporate);
                if (record) {
                    // Store the matched record in state
                    setSelected({ record });
                }
            });
        }
    }, [selectedCorporate]);

    const { t, i18n } = useTranslation(); // To Translate to another language

    // Variable used for controlling the modal
    const [isModalVisible, setModalVisible] = useState(false);

    /**
     * Open the modal
     */
    const showStydecontent = () => {
        setModalVisible(true);
    };

    /**
     * Close the modal
     */
    const handleModalClose = () => {
        setModalVisible(false);
    };

    useEffect(async () => {
        if (value) {
            // setCorporate(true)
            let data = await Customers.getCustomerWithId(value);
            let corporate;
            corporate = {
                record: data.result,
            };
            setSelected(corporate);
        }
    }, []);

    // const onUpdateSelect = (value, updateMethod) => {
    //     if (value) {
    //         updateMethod(value);
    //     } else {
    //         updateMethod('');
    //     }
    // };

    /**
     * Update the selected value and call the provided update method.
     *
     * @param {string} value - The selected value.
     * @param {Function} updateMethod - The method to update the corporate section value.
     * @param {string} type - The selected type.
     */
    async function onselectChange(value, type, updateMethod) {
        updateMethod(value);

        // set values
        let record = {
            // package_value: packageValue.items[0].ir_itemptr,
            type: type.selected_type,
            corporate_pointer: value,
        };

        if (packageValue && packageValue.items.length > 0) {
            record = {
                ...record,
                package_value: packageValue.items[0].ir_itemptr,
            };
        }
        callback(record);
    }

    return (
        <Card className="corporate-section">
            <Title level={5}>{t('Corporate')}</Title>
            <ReferenceSelect
                label="cc_desc"
                mode="nura-base"
                model={Customers}
                field={'cc_code'}
                value={selectedCorporate || corporate || selected?.record?.cc_code}
                disabled={selectedCorporate ? disableCorporate : false}
                allowClear={true}
                // onChange={(entry, record) => {
                //     onUpdateSelect(entry, setCorporate);

                //     setSelected(record);
                // }}
                config={{
                    queries: [
                        {
                            field: 'cc_active',
                            value: 'Y',
                        },
                    ],
                }}
                onChange={(entry, record) => {
                    onselectChange(entry, { selected_type: 'C' }, setCorporate);
                    setSelected(record);
                }}
            />

            <div className="footer">
                {selected && selected.record && selected.record.cc_styledcontent && (
                    <Button size={'small'} onClick={showStydecontent}>
                        {t('View offers')}
                    </Button>
                )}
            </div>
            <Modal visible={isModalVisible} onCancel={handleModalClose} footer={null}>
                {selected && selected.record && selected.record.cc_styledcontent ? (
                    <div dangerouslySetInnerHTML={{ __html: selected.record.cc_styledcontent }}></div>
                ) : (
                    <p>{t('No content available')}</p>
                )}
            </Modal>
        </Card>
    );
}
